import { render, staticRenderFns } from "./CourseMenu.vue?vue&type=template&id=4f101178"
import script from "./CourseMenu.vue?vue&type=script&lang=ts"
export * from "./CourseMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports